import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=54a4e6d4&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=54a4e6d4&prod&scoped=true&lang=css"
import style1 from "./Setting.vue?vue&type=style&index=1&id=54a4e6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4e6d4",
  null
  
)

export default component.exports